import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { delay as _delay } from "@azure/core-util";
import { Poller } from "@azure/core-lro";
/**
 * This is the poller returned by {@link BlobClient.beginCopyFromURL}.
 * This can not be instantiated directly outside of this package.
 *
 * @hidden
 */

export var BlobBeginCopyFromUrlPoller = /*#__PURE__*/function (_Poller) {
  _inherits(BlobBeginCopyFromUrlPoller, _Poller);

  var _super = _createSuper(BlobBeginCopyFromUrlPoller);

  function BlobBeginCopyFromUrlPoller(options) {
    var _this;

    _classCallCheck(this, BlobBeginCopyFromUrlPoller);

    var blobClient = options.blobClient,
        copySource = options.copySource,
        _options$intervalInMs = options.intervalInMs,
        intervalInMs = _options$intervalInMs === void 0 ? 15000 : _options$intervalInMs,
        onProgress = options.onProgress,
        resumeFrom = options.resumeFrom,
        startCopyFromURLOptions = options.startCopyFromURLOptions;
    var state;

    if (resumeFrom) {
      state = JSON.parse(resumeFrom).state;
    }

    var operation = makeBlobBeginCopyFromURLPollOperation(Object.assign(Object.assign({}, state), {
      blobClient: blobClient,
      copySource: copySource,
      startCopyFromURLOptions: startCopyFromURLOptions
    }));
    _this = _super.call(this, operation);

    if (typeof onProgress === "function") {
      _this.onProgress(onProgress);
    }

    _this.intervalInMs = intervalInMs;
    return _this;
  }

  _createClass(BlobBeginCopyFromUrlPoller, [{
    key: "delay",
    value: function delay() {
      return _delay(this.intervalInMs);
    }
  }]);

  return BlobBeginCopyFromUrlPoller;
}(Poller);
/**
 * Note: Intentionally using function expression over arrow function expression
 * so that the function can be invoked with a different context.
 * This affects what `this` refers to.
 * @hidden
 */

var cancel = /*#__PURE__*/function () {
  var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var options,
        state,
        copyId,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            state = this.state;
            copyId = state.copyId;

            if (!state.isCompleted) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", makeBlobBeginCopyFromURLPollOperation(state));

          case 5:
            if (copyId) {
              _context.next = 8;
              break;
            }

            state.isCancelled = true;
            return _context.abrupt("return", makeBlobBeginCopyFromURLPollOperation(state));

          case 8:
            _context.next = 10;
            return state.blobClient.abortCopyFromURL(copyId, {
              abortSignal: options.abortSignal
            });

          case 10:
            state.isCancelled = true;
            return _context.abrupt("return", makeBlobBeginCopyFromURLPollOperation(state));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function cancel() {
    return _cancel.apply(this, arguments);
  }

  return cancel;
}();
/**
 * Note: Intentionally using function expression over arrow function expression
 * so that the function can be invoked with a different context.
 * This affects what `this` refers to.
 * @hidden
 */


var update = /*#__PURE__*/function () {
  var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var options,
        state,
        blobClient,
        copySource,
        startCopyFromURLOptions,
        result,
        _result,
        copyStatus,
        copyProgress,
        prevCopyProgress,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            state = this.state;
            blobClient = state.blobClient, copySource = state.copySource, startCopyFromURLOptions = state.startCopyFromURLOptions;

            if (state.isStarted) {
              _context2.next = 12;
              break;
            }

            state.isStarted = true;
            _context2.next = 7;
            return blobClient.startCopyFromURL(copySource, startCopyFromURLOptions);

          case 7:
            result = _context2.sent;
            // copyId is needed to abort
            state.copyId = result.copyId;

            if (result.copyStatus === "success") {
              state.result = result;
              state.isCompleted = true;
            }

            _context2.next = 27;
            break;

          case 12:
            if (state.isCompleted) {
              _context2.next = 27;
              break;
            }

            _context2.prev = 13;
            _context2.next = 16;
            return state.blobClient.getProperties({
              abortSignal: options.abortSignal
            });

          case 16:
            _result = _context2.sent;
            copyStatus = _result.copyStatus, copyProgress = _result.copyProgress;
            prevCopyProgress = state.copyProgress;

            if (copyProgress) {
              state.copyProgress = copyProgress;
            }

            if (copyStatus === "pending" && copyProgress !== prevCopyProgress && typeof options.fireProgress === "function") {
              // trigger in setTimeout, or swallow error?
              options.fireProgress(state);
            } else if (copyStatus === "success") {
              state.result = _result;
              state.isCompleted = true;
            } else if (copyStatus === "failed") {
              state.error = new Error("Blob copy failed with reason: \"".concat(_result.copyStatusDescription || "unknown", "\""));
              state.isCompleted = true;
            }

            _context2.next = 27;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](13);
            state.error = _context2.t0;
            state.isCompleted = true;

          case 27:
            return _context2.abrupt("return", makeBlobBeginCopyFromURLPollOperation(state));

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[13, 23]]);
  }));

  function update() {
    return _update.apply(this, arguments);
  }

  return update;
}();
/**
 * Note: Intentionally using function expression over arrow function expression
 * so that the function can be invoked with a different context.
 * This affects what `this` refers to.
 * @hidden
 */


var toString = function toString() {
  return JSON.stringify({
    state: this.state
  }, function (key, value) {
    // remove blobClient from serialized state since a client can't be hydrated from this info.
    if (key === "blobClient") {
      return undefined;
    }

    return value;
  });
};
/**
 * Creates a poll operation given the provided state.
 * @hidden
 */


function makeBlobBeginCopyFromURLPollOperation(state) {
  return {
    state: Object.assign({}, state),
    cancel: cancel,
    toString: toString,
    update: update
  };
}